// extracted by mini-css-extract-plugin
module.exports = {"footer":"VfzGGROK6s32NwpoAhyMo","normalText":"_1UxaypD3kg8kDstIgqlGQi"};